module.exports = __webpack_public_path__ + "img/Jump Casting98.b4c50fc3.jpg";